import { render, staticRenderFns } from "./score-card.vue?vue&type=template&id=12304f36&scoped=true&"
import script from "./score-card.vue?vue&type=script&lang=js&"
export * from "./score-card.vue?vue&type=script&lang=js&"
import style0 from "./score-card.vue?vue&type=style&index=0&id=12304f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12304f36",
  null
  
)

export default component.exports